import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  constructor() { }

  @Input() pageHeaderVm: IPageHeaderViewModel;

  @Output() prevClicked = new EventEmitter();
  @Output() nextClicked = new EventEmitter();
  
  @Output() backClicked = new EventEmitter();
  @Output() editClicked = new EventEmitter();
  @Output() deleteClicked = new EventEmitter();
  @Output() infoClicked = new EventEmitter();
  @Output() copyClicked = new EventEmitter();

  ngOnInit(): void {
  }

}

/**
 * 
 */
export interface IPageHeaderViewModel {
  title: string;
  subTitle?: string;

  formDisplayed?: boolean;

  edit?: boolean;
  delete?: boolean;
  info?: boolean;
  copy?: boolean;

  navVm?: {
    prevEnabled: boolean;
    nextEnabled: boolean;
  };
}